import Data from "../Data";
import "../Taketour.css";
import StyleItem from "../StyleItem";
import heroCarpool from "../../../../assets/images/hero-carpool.png"

const CarPool = () => {
    const { carPoolData } = Data();
    return (
        <div>
            {carPoolData.map((item, index) => (
                <StyleItem key={index} data={item} />
            ))}
            <div className="taketour-image-section">
                <img src={heroCarpool} alt="" />
            </div>
        </div>
    )
}

export default CarPool
